<template>
    <div class="inner-box">
        <div class="title">개인정보 처리방침</div>
        <div class="title-s">방문 예약 시스템의 개인정보 처리방침입니다.</div>

        <h1>개인정보 처리방침</h1>
        <table class="visit-info-table">
            <tr>
                <td>
                    <div class="policy">
                        <h4>롯데에너지머티리얼즈(이하 “회사”라고 합니다)는 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에 의거한 개인정보취급방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.</h4>

                        <div>
                            <h4>회사의 개인정보취급방침은 다음과 같은 내용을 담고 있습니다.</h4>
                            <ul>
                                <li>
                                   1. 수집하는 개인정보의 항목 및 수집방법
                                </li>
                                <li>
                                    2. 개인정보의 수집 및 이용목적
                                </li>
                                <li>
                                    3. 개인정보 공유 및 제공
                                </li>
                                <li>
                                    4. 개인정보의 취급위탁
                                </li>
                                <li>
                                    5. 개인정보의 보유 및 이용기간
                                </li>
                                <li>
                                    6. 개인정보 파기절차 및 방법
                                </li>
                                <li>
                                    7. 이용자 및 법정대리인의 권리와 그 행사방법
                                </li>
                                <li>
                                    8. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항
                                </li>
                                <li>
                                    9. 개인정보의 기술적/관리적 보호 대책
                                </li>
                                <li>
                                    10. 개인정보관리책임자 및 담당자의 연락처
                                </li>
                                <li>
                                    11. 고지의 의무
                                </li>
                            </ul>
                        </div>

                        <h4>• 수집하는 개인정보의 항목 및 수집방법</h4>
                        <h4>가. 수집하는 개인정보의 항목</h4>
                        <table class="ptable">
                            <col width="30%"><col width="30%"><col width="40%">
                            <tr>
                                <td>구분</td>
                                <td>필수 수집항목</td>
                                <td>선택 수집항목</td>
                            </tr>
                            <tr>
                                <td style="padding:20px 0 20px 0">웹 방문신청 페이지</td>
                                <td style="padding:20px 0 20px 0">성명, 생년월일, 휴대전화,<br>소속사명, 소속회사 주소</td>
                                <td style="padding:20px 0 20px 0">차량정보, 노트북 정보</td>
                            </tr>
                        </table><br>
                        <h4>나. 개인정보 수집방법</h4>
                        <p>회사는 출입관리시스템의 운영을 위해 필요한 최소한의 범위 내에서 위와 같은 개인정보를 수집합니다.</p>
                        <br><br>
                        <h4>• 개인정보의 수집 및 이용목적</h4>
                        <p>회사는 출입관리시스템을 통한 서비스 제공을 위해 정보주체로부터 필요한 최소한의 사항(이하 ‘필수항목’) 및 그 외 추가적 사항(이하 ‘선택항목’)에 대한 개인정보를 수집합니다.</p>
                        <p>이 때 정보주체는 필수항목에 대한 동의를 해야 동 서비스를 이용할 수 있으며, 선택항목의 경우에는 동의하지 않더라도 동 서비스 이용은 가능하나, 동 서비스 이용에 제한이 있을 수 있습니다.</p><br>
                        <p>회사 방문관련 이력관리</p>
                        <p>회사의 개인정보 수집은 정보주체의 회사 방문에 따른 이력(사고경력 포함)관리, 직원 비위행위 조사를 위해서도 이용됩니다. 사고경력이란, [규정준수 이행약정]에 위반한 경력을 말합니다.</p>
                        <br>
                        <h4>• 개인정보의 공유 및 제공</h4>
                        <p>회사는 이용자들의 개인정보를 "2. 개인정보의 수집목적 및 이용목적"에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.</p>
                        <br>
                        <h4>이용자들이 사전에 공개에 동의한 경우</h4>
                        <h4>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</h4>
                        <br>
                        <h4>• 개인정보의 취급위탁</h4>
                        <p>회사는 제3자에게 개인정보를 위탁하고 있지 않으며, 추후 위탁계약이 발생할 경우, 해당 사이트를 통해 고지하고, 본 '개인정보취급방침'의 내용을 갱신하도록 하겠습니다.</p>
                        <br>
                        <h4>• 개인정보의 보유 및 이용기간</h4>
                        <p>이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다.
                            단, 분쟁처리, 본인확인 등 회사 내부 방침에 의해 정보보유가 필요할 경우, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다.</p>
                        <h4>보존 항목</h4>
                        <p>성명, 생년월일, 휴대전화, 회사명, 회사주소</p>
                        <h4>보존 근거</h4>
                        <p>신용정보의 이용 및 보호에 관한 법률</p>
                        <h4>보존 기간</h4>
                        <p>3년</p>
                        <br>
                        <h4>※ 신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년 (신용정보의 이용 및 보호에 관한 법률)</h4>
                        <br>
                        <h4>• 개인정보 파기절차 및 방법</h4>
                        <p>이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다.
                            회사의 개인정보 파기절차 및 방법은 다음과 같습니다.</p>
                        <h4>가. 파기절차</h4>
                        <p>이용자가 고객문의 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조)일정 기간 저장된 후 파기됩니다.
                               동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.</p>
                        <h4>나. 파기방법</h4>
                        <p>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
                            전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</p>
                        <br>
                        <h4>• 이용자 및 법정대리인의 권리와 그 행사방법</h4>
                        <p>이용자 및 법정 대리인께서는 언제든지 고객문의 등을 위해 입력한 개인정보에 대한 삭제를 요청하실 수 있습니다.</p>
                        <p>입력한 개인정보에 대한 확인 및 삭제 요청은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 조치하겠습니다.</p>
                        <p>회사는 이용자 혹은 법정 대리인의 요청에 의해 삭제된 개인정보는 "5. 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.</p>
                        <br>
                        <h4>• 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</h4>
                        <p>회사는 이용자들의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.</p>
                        <p>쿠키는 웹사이트를 운영하는데 이용되는 서버(HTTP)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.</p>
                        <h4>가. 쿠키의 사용 목적</h4>
                        <p>이용자들이 방문한 회사의 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 뉴스편집, 이용자 규모 등을 파악하여 이용자에게 최적화된 정보 제공을 위하여 사용합니다.</p>
                        <h4>나. 쿠키 설정 거부 방법</h4>
                        <p>이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.</p>
                        <p>쿠키 설정을 거부하는 방법으로는 이용자가 사용하는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.</p>
                        <br>
                        <h4>• 개인정보의 기술적/관리적 보호 대책</h4>
                        <p>회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적/관리적 대책을 강구하고 있습니다.</p>
                        <h4>가. 개인정보의 암호화</h4>
                        <p>출입등록 이용을 위해 입력한 개인정보 중 이름, 휴대폰번호, 회사명은 암호화되어 저장 및 관리되고 있어 본인만이 알 수 있습니다.</p>
                        <h4>나. 해킹 등에 대비한 대책</h4>
                        <p>회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다.</p>
                        <p>개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나 손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.</p>
                        <h4>다. 취급 직원의 최소화 및 교육</h4>
                        <p>회사의 개인정보관련 취급 직원은 담당자에 한정시키고 있고 이를 위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며, 담당자에 대한 수시 교육을 통하여 개인정보취급방침의 준수를 항상 강조하고 있습니다.</p>
                        <h4>라. 개인정보보호전담기구의 운영</h4>
                        <p>사내 개인정보보호전담기구 등을 통하여 개인정보취급방침의 이행사항 및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고 있습니다.</p>
                        <p>단, 이용자 본인의 부주의나 인터넷상의 문제로 개인정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지 않습니다.</p>
                        <br>
                        <h4>• 개인정보관리책임자 및 담당자의 연락처</h4>
                        <p>귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다.</p>
                        <p>회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다.</p>
                        <h4>개인정보 관리 책임자 : 보안파트</h4>
                        <h4>개인정보 운영 책임자 : 보안파트</h4>
                        <h4>전화번호 : 02.707.9222</h4>
                        <h4>이메일 주소 : jeongwoo.choi@iljin.co.kr</h4>
                        <p>기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.</p>
                        <p>&nbsp;&nbsp;1) 개인분쟁조정위원회 (www.1336.or.kr/1336)</p>
                        <p>&nbsp;&nbsp;2) 정보보호마크인증위원회 (www.eprivacy.or.kr/02-580-0533~4)</p>
                        <p>&nbsp;&nbsp;3) 대검찰청 인터넷범죄수사센터 (icic.sppo.go.kr/02-3480-3600)</p>
                        <p>&nbsp;&nbsp;4) 경찰청 사이버테러대응센터 (www.ctrc.go.kr/02-392-0330)</p>
                        <br>
                        <h4>• 고지의 의무</h4>
                        <p>현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지의 '공지사항'을 통해 고지할 것입니다.</p>
                        <h4>공고일자</h4>
                        <p>2021년 1월 1일</p>
                        <h4>시행일자</h4>
                        <p>2021년 1월 1일</p>
                    </div>
                </td>
            </tr>
        </table>

        <div style="height:50px"></div>

        <div class="btn">
            <button v-on:click="main()">메인홈</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "policy",
        data(){
            return {

            }
        },
        methods: {
            main(){
                this.$router.push({path: `/`});
            }
        },
        created(){

        }
    }
</script>

<style scoped>
    .inner-box{
        height: 100%;
        width:95%;
        left: 0;
        right: 0;
        margin: 0 auto 30px;
    }

    @media (min-width: 1000px) {
        .inner-box{
            width:1000px;
        }
    }

    .title{
        font-size:40px;
        text-align:center;
        margin-top:50px;
        padding:0px 0;
    }

    .title-s{
        font-size:15px;
        color:#666;
        text-align:center;
        padding:0 0 30px 0;
    }

    .inner-box h1{
        font-size:20px;
        padding:50px 0 10px 0;
        font-weight: bold;
    }

    .inner-box button{
        margin:15px 5px;
        padding:10px;
        border:1px solid #d5d5d5;
        text-align:center;
    }

    .inner-box button:first-child{
        background-color: #b3b3b3;
        color:#fff;
    }

    .inner-box .btn{
        text-align:center;
    }

    table.visit-info-table{
        border-top: 1px solid #aaaaaa;
        width: 100%;
    }

    .policy {
        width: 100%;
        border-bottom: 1px solid #aaaaaa;
        padding: 30px 20px;
        color: #999;
        font-size: 14px;
        line-height: 24px;
    }

    .policy div {
        border-top: 2px solid #333;
        margin:30px 0 30px 0;
        padding-top:10px;
    }

    .policy div ul{
        padding-left:20px;
    }

    h4 {
        margin: 0;
        padding: 0;
        color: #333;
    }

    .ptable {
        margin-top:10px;
        border-top: 1px solid #333;
    }

    .ptable td{
        text-align:center;
        padding:5px;
        border-bottom: 1px solid #aaaaaa;
    }
</style>